
@if (contactMode) {
  <div class="spacer-bottom">
    <div class="ac-color animated {{options.stepDirectionClass}}" style="padding:3px 16px 16px;">
      @if (contactMode) {
        <div class="my-panel mb-base no-shadow text-base condensed-fields">
          <div class="my-panel-body">
            <div class="_panel-title"><div>{{'whoIsPaying' | translate}}</div></div>
            <form #f="ngForm" [formGroup]="contactForm" class="condensed-fields">
              <div class="row small-gutters">
				  <div class="col-12">
					  <mat-form-field color="accent" appearance="outline">
						  <mat-label>{{'name' | translate}}</mat-label>
						  <input #name name="name" matInput formControlName="name" required>
					  </mat-form-field>
				  </div>
				  <div class="col-12">
					  <mat-form-field color="accent" appearance="outline" class="with-pad">
						  <mat-label>{{'mobile' | translate}}</mat-label>
						  <oao-mat-intl-tel-input [preferredCountries]="appService.regionArgs.phonePreferredCountries"
			                                      [onlyCountries]="appService.regionArgs.phoneOnlyCountries"
			                                      [enablePlaceholder]="true"
			                                      [enableSearch]="true"
			                                      [searchPlaceholder]="appService.translate('search')"
			                                      format="national"
			                                      required
			                                      name="phone"
			                                      formControlName="phone"
			                                      #phone></oao-mat-intl-tel-input>
						  <!--<mat-hint>e.g. {{phone.selectedCountry.placeHolder}}</mat-hint>-->
						  <!--<mat-error *ngIf="f.form.controls['phone']?.errors?.required">Required Field</mat-error>-->
						  @if (f.form.controls['phone']?.errors?.validatePhoneNumber) {
							  <mat-error>{{'invalid_phone' | translate}}</mat-error>
						  }
					  </mat-form-field>
				  </div>
				@if (customerDetailsRequired) {
					<div class="col-12">
						<mat-form-field color="accent" appearance="outline">
							<mat-label>{{'business_or_user_id' | translate}}</mat-label>
							<input name="businessId" formControlName="businessId" matInput type="tel" >
						</mat-form-field>
					</div>
				}
              </div>
            </form>
            <div class="mt-2">
              @if (contactMode) {
                <button mat-raised-button color="accent" class="lg main-continue-btn" type="submit" (click)="applyContact($event)">
                  <div class="_inner">
                    <span>{{'continue' | translate}}</span>
                    <div class="_cont rotate-rtl"><mat-icon svgIcon="arrow_next"></mat-icon></div>
                  </div>
                </button>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
} @else {
  <form #paymentForm="ngForm" class="spacer-bottom">
    <div class="ac-color animated {{options.stepDirectionClass}}" style="padding:10px 16px 16px;">
      <!--<app-signup-banner _class="mb-1" [position]="'pay'"></app-signup-banner>-->
      <div class="condensed-fields">
        <!--START PAYMENT SELECTION-->
        <div class="my-panel-title"><div>{{(showPaymentTypes ? 'PAY_WITH' : 'additional_details') | translate}}</div></div>
        <ng-container>
          <div class="saved-payments-container" [class._half-width]="ui.paymentMethods.length > 3">
            <!--start saved payments-->
            @if (walletPm) {
              <div class="wallet-payment-container" [class.active]="$storage.wallet?.ccinfo == walletPm">
                @for (pm of $storage.wallet.pms; track pm; let last = $last) {
                  <div class="_pm" (click)="setWalletPayment(pm)" [class._last]="last" [class._active]="pm == walletPm">
                    <mat-icon svgIcon="credit_card"></mat-icon>
                    <span>
                      <span class="inline">{{ pm.paymentType == 'adyen' ? pm.issuer : ('PMS.' + pm.paymentType | translate) }}</span>
                      {{pm.displayPan}}
                    </span>
                    @if (['creditCard', 'creditGuard'].includes(pm.paymentType)) {
                      <strong class="text-xs ms-2" [ngClass]="{'text-danger':pm.expired }">
                        {{pm | paymentExp}}
                      </strong>
                    }
                    <i class="text-xs text-truncate ms-2">{{pm.comment}}</i>
                  </div>
                }
              </div>
              <div class="or-separator"><span>{{'OR' | translate}}</span></div>
            }
            <!--end saved payments-->
            <!--start google/apple payments-->
            @if (expayService.showNativePaymentButtons($storage)) {
              <div class="_native-payments-container">
                <div class="apple-pay-button-wrapper"></div>
                <div class="google-pay-button-wrapper" (click)="initGooglePaymentRequest()"></div>
              </div>
            }
            <!--end google/apple payments-->
            <!--start generic payments-->
            @for (pm of ui.paymentMethods; track pm) {
              <button type="button" color="accent" class="pm-button-stroked _pm" style="justify-content:start" [class.active]="ccinfo.account == pm._id" (click)="setPaymentMethod(ccinfo, pm)">
                <!--<mat-icon svgIcon="credit_card" class="me-2"></mat-icon>-->
                <div class="_pmlogo me-2" [ngStyle]="{'background-image': 'url(' + (pm.paymentType | pmimage) + ')'}"></div>
                <div style="text-align:start; line-height: 18px;">{{pm.name | translate}}</div>
              </button>
            }
            <!--end generic payments-->
          </div>
        </ng-container>
        <!--END PAYMENT SELECTION-->
        <!--START PM ADDITIONAL DETAILS-->
        @if (ccinfo.account && showPaymentTypes) {
          @if (!appService.user) {
            <hr />
          }
          @if (ccinfo.paymentMethod) {
            <div style="margin-bottom: 15px;">
              @switch (ccinfo.paymentMethod) {
                @case ('giftCard') {
                  <div>
                    <div class="row small-gutters">
                      <div class="col-12">
                        @if ($storage.giftCards.hasMultipleAccounts) {
                          <mat-form-field appearance="outline">
                            <mat-label>{{'_GIFTCARD.select_card' | translate}}</mat-label>
                            <mat-select [(ngModel)]="ccinfo.account" (selectionChange)="checkGiftCardAccount(ccinfo);" name="gCardAccount" requiered>
                              @for (acc of $storage.giftCards.accounts; track acc) {
                                <mat-option [value]="acc._id">
                                  {{acc.name}}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        }
                      </div>
                      <div class="col-12">
                        <mat-form-field appearance="outline">
                          <mat-label>{{'_GIFTCARD.number' | translate}}</mat-label>
                          <input [(ngModel)]="ccinfo.number" name="gnumber" id="gNumber" matInput type="tel" required pattern="[0-9]*">
                          @if (ccinfo.number) {
                            <mat-icon matSuffix (click)="ccinfo.number = null">close</mat-icon>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-12">
                        <mat-form-field appearance="outline">
                          <mat-label>{{'_GIFTCARD.cvv' | translate}}</mat-label>
                          <input [(ngModel)]="ccinfo.cvv" name="cvv" matInput placeholder="{{'_GIFTCARD.cvv' | translate}}" type="tel"
                            pattern="[0-9]*" class="text-center">
                            @if (ccinfo.cvv) {
                              <mat-icon matSuffix (click)="ccinfo.cvv = null">close</mat-icon>
                            }
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  }
                  @case ('creditCard') {
                    <div>
                      <div class="row small-gutters">
                        <div class="col-12">
                          <mat-form-field appearance="outline">
                            <mat-label>{{'credit_card_number' | translate}}</mat-label>
                            <input [(ngModel)]="ccinfo.pan" name="cardnumber" id="cardNumber" matInput type="tel" required pattern="[0-9]*"
                              validCreditCard [ccInfo]="ccinfo" #cc="ngModel">
                              @if (ccinfo.pan) {
                                <mat-icon matSuffix (click)="ccinfo.pan = null" class="me-2">close</mat-icon>
                              }
                              <mat-icon matSuffix [svgIcon]="ccinfo && ccinfo.brand || 'cc'" matSuffix (click)="ccinfo.pan = null"></mat-icon>
                              <!--<mat-error *ngIf="cc.dirty && cc.errors?.creditCard">{{cc.errors.creditCard | translate}}</mat-error>-->
                            </mat-form-field>
                          </div>
                          <div class="col-5">
                            <mat-form-field appearance="outline">
                              <mat-label>{{'expiration' | translate}}</mat-label>
                              <input [(ngModel)]="ccinfo.expiration" name="newexp" matInput placeholder="mm-yy" type="tel"
                                required validCardExpiration ccinfo="ccinfo" autocomplete="cc-exp" class="ltr-field text-center" [ccInfo]="ccinfo" #newexp="ngModel">
                                @if (ccinfo.expiration) {
                                  <mat-icon matSuffix (click)="ccinfo.expiration = null">close</mat-icon>
                                }
                              </mat-form-field>
                            </div>
                            <div class="col-7">
                              <mat-form-field appearance="outline">
                                <mat-label>{{'cvv' | translate}}</mat-label>
                                <input [(ngModel)]="ccinfo.cvv" name="cvv" matInput placeholder="{{'CVV'}}" type="tel" required
                                  pattern="[0-9]*" class="text-center" maxlength="4">
                                  @if (ccinfo.cvv) {
                                    <mat-icon matSuffix (click)="ccinfo.cvv = null">close</mat-icon>
                                  }
                                </mat-form-field>
                              </div>
                              <div class="col-12">
                                @if (ccinfo.requireIdPhoneTrans) {
                                  <mat-form-field appearance="outline">
                                    <mat-label>{{'ID_CARD' | translate}}</mat-label>
                                    <input [(ngModel)]="ccinfo.idCard" name="idCard" matInput type="tel" required pattern="[0-9]*"
                                      validIdCard #idCard="ngModel">
                                      @if (ccinfo.idCard) {
                                        <mat-icon matSuffix (click)="ccinfo.idCard = null">close</mat-icon>
                                      }
                                      <!--<mat-error *ngIf="idCard.dirty && idCard.errors?.creditCard">{{idCard.errors.creditCard | translate}}</mat-error>-->
                                    </mat-form-field>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                          @case ('Cibus') {
                            <div>
                              <mat-form-field appearance="outline">
                                <mat-label>{{'credit_card_number' | translate}}</mat-label>
                                <input [(ngModel)]="ccinfo.pan" name="cardnumber" id="cardNumber" matInput type="tel" required pattern="[0-9]*">
                                @if (ccinfo.pan) {
                                  <mat-icon matSuffix (click)="ccinfo.pan = null">close</mat-icon>
                                }
                              </mat-form-field>
                            </div>
                          }
                          @case ('10bis') {
                            <div>
                              <mat-form-field appearance="outline">
                                <mat-label>{{'credit_card_number' | translate}}</mat-label>
                                <input [(ngModel)]="ccinfo.pan" name="cardnumber" id="cardNumber" matInput type="tel" required
                                  pattern="[0-9]*">
                                  @if (ccinfo.pan) {
                                    <mat-icon matSuffix (click)="ccinfo.pan = null">close</mat-icon>
                                  }
                                </mat-form-field>
                              </div>
                            }
                            @case ('TavHazahav') {
                              <div>
                                <mat-form-field appearance="outline">
                                  <mat-label>{{'credit_card_number' | translate}}</mat-label>
                                  <input [(ngModel)]="ccinfo.pan" name="cardnumber" id="cardNumber" matInput type="tel" required
                                    pattern="[0-9]*">
                                    @if (ccinfo.pan) {
                                      <mat-icon matSuffix (click)="ccinfo.pan = null">close</mat-icon>
                                    }
                                  </mat-form-field>
                                </div>
                              }
                            }
                          </div>
                        }
                        <!--END PM ADDITIONAL DETAILS-->
                        <!--START PM SECURITY DETAILS-->
                        @if (!['Stripe', 'AuthorizeNet'].includes(ccinfo.paymentMethod) && ccinfo.paymentVerificationStrategy && ccinfo.paymentVerificationStrategy != 'none') {
                          <div class="text-md font-bold mb-3 mt-3">{{'billing_address' | translate}}</div>
                          @if (ccinfo.paymentVerificationStrategy == 'fullAddress') {
                            <div class="row small-gutters">
                              <div class="col-12">
                                <mat-form-field appearance="outline">
                                  <mat-label>{{'address' | translate}}</mat-label>
                                  <input [(ngModel)]="ccinfo.address" name="address" matInput placeholder="{{'address' | translate}}" required>
                                  @if (ccinfo.address) {
                                    <mat-icon matSuffix (click)="ccinfo.address = null">close</mat-icon>
                                  }
                                </mat-form-field>
                              </div>
                              <div class="col-12">
                                <mat-form-field appearance="outline">
                                  <mat-label>{{'city' | translate}}</mat-label>
                                  <input [(ngModel)]="ccinfo.city" name="city" matInput placeholder="{{'city' | translate}}" required>
                                  @if (ccinfo.city) {
                                    <mat-icon matSuffix (click)="ccinfo.city = null">close</mat-icon>
                                  }
                                </mat-form-field>
                              </div>
                              <div class="col-12">
                                <mat-form-field appearance="outline">
                                  <mat-label>{{'state' | translate}}*</mat-label>
                                  <mat-select [(ngModel)]="ccinfo.state" name="usState" requiered [formControl]="stateFormControl">
                                    @for (state of usStates; track state) {
                                      <mat-option [value]="state.v">
                                        {{state.t}}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            </div>
                          }
                          <mat-form-field appearance="outline">
                            <mat-label>{{'zip' | translate}}</mat-label>
                            <input [(ngModel)]="ccinfo.zip" name="zip" matInput type="text" required maxlength="10" validZip>
                            @if (ccinfo.number) {
                              <mat-icon matSuffix (click)="ccinfo.zip = null">close</mat-icon>
                            }
                          </mat-form-field>
                          <hr />
                        }
                        <!--END PM SECURITY DETAILS-->
                        @if (appService.user && enableSaveToWallet) {
                          <mat-form-field appearance="outline">
                            <mat-label>{{'comments' | translate}}</mat-label>
                            <input [(ngModel)]="ccinfo.comment" name="comment" matInput>
                          </mat-form-field>
                        }
                        @if (!appService.user) {
                          @if (ccinfo.paymentMethod != 'Meshulam') {
                            <div class="row small-gutters">
                              <div class="col-12">
                                <mat-form-field color="accent" appearance="outline">
                                  <mat-label>{{'card_holder_name' | translate}}</mat-label>
                                  <input [(ngModel)]="$storage.contact.firstName" name="firstName" matInput required>
                                  @if ($storage.contact.firstName) {
                                    <mat-icon matSuffix (click)="$storage.contact.firstName = null">close</mat-icon>
                                  }
                                </mat-form-field>
                              </div>
                              <div class="col-12">
                                <form #f="ngForm" [formGroup]="phoneForm" class="condensed-fields">
                                  <mat-form-field color="accent" appearance="outline" class="with-pad">
                                    <mat-label>{{'mobile' | translate}}</mat-label>
                                    <oao-mat-intl-tel-input [preferredCountries]="appService.regionArgs.phonePreferredCountries"
                                      [onlyCountries]="appService.regionArgs.phoneOnlyCountries"
                                      [enablePlaceholder]="true"
                                      [enableSearch]="true"
                                      [searchPlaceholder]="appService.translate('search')"
                                      required
                                      format="national"
                                      name="phone"
                                      formControlName="phone"
                                    #phone></oao-mat-intl-tel-input>
                                    <!--<mat-hint>e.g. {{phone.selectedCountry.placeHolder}}</mat-hint>-->
                                    <!--<mat-error *ngIf="f.form.controls['phone']?.errors?.required">Required Field</mat-error>-->
                                    @if (f.form.controls['phone']?.errors?.validatePhoneNumber) {
                                      <mat-error>{{'invalid_phone' | translate}}</mat-error>
                                    }
                                  </mat-form-field>
                                </form>
                              </div>
                            </div>
                          }
                          <div class="text-md">
                            <mat-checkbox class="text-md" name="updatePaymentInfo" [(ngModel)]="$storage.contact.contractApprove">
                              {{'READ_AND_APPROVE_CONTRACT' | translate}}
                            </mat-checkbox>
                            <div class="text-base" style="display:inline-flex; gap:5px; margin-inline-start: 50px; position:relative; top:-10px;">
                              <a class="inline link" (click)="appService.showContractDialog('contract')">
                                {{'READ_AND_APPROVE_CONTRACT_C' | translate}}
                              </a>
                              <div>,</div>
                              <a class="inline link" (click)="appService.showContractDialog('privacy')">
                                {{'READ_AND_APPROVE_CONTRACT_D' | translate}}
                              </a>
                            </div>
                          </div>
                        }
                        @if (enableSaveToWallet && appService.user && !ccinfo.$$isExternal && ccinfo.paymentMethod && !$storage.rosConfig?.payments?.walletDisabled) {
                          <div class="">
                            <mat-checkbox class="example-margin" name="updatePaymentInfo" [(ngModel)]="ui.updatePaymentInfo">
                              {{'SAVE_ACCOUNT_PAYMENT_INFO' | translate}}
                            </mat-checkbox>
                          </div>
                        }
                      }
                    </div>
                    <div class="grecaptcha-text ltr">
                      <div>This site is protected by reCAPTCHA and the Google</div>
                      <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
                      <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
                    </div>
                  </div>
                  <!--START BOTTOM ACTION-->
                  <div class="ac-color p-3 pb-4 fixed-bottom fix-pos-botton">
                    <button mat-raised-button color="accent" class="lg main-continue-btn" type="submit" (click)="submit(paymentForm, $event)">
                      <div class="_inner">
                        <span>{{'PAY' | translate}}</span>
                        <b>{{cache.grandTotalPlusTip | lcurrency}}</b>
                        <div class="_cont rotate-rtl"><mat-icon svgIcon="arrow_next"></mat-icon></div>
                      </div>
                    </button>
                  </div>
                  <!--END BOTTOM ACTION-->
                </form>
              }



